const domain = 'brainos.com';

const isProd =
  document.location.hostname === `health.${domain}` ||
  document.location.hostname === `status.${domain}`;

export const BUCKET_ENV = isProd ? 'prod' : 'nonprod';

export const DOMAIN = isProd ? 'com' : 'dev';

const SUBENV = process.env.REACT_APP_SUBENV;

export const BUCKET_URL = `https://storage.googleapis.com/bc-${BUCKET_ENV}-roc-1a1c${
  SUBENV ? `-${SUBENV}` : ''
}-uptime-data`;

export const FILE_PATH = '/uptime-statuses.json';
